module.exports = __webpack_public_path__ + "static/media/kids_45.327dd381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_45.jpg
// module id = 5901
// module chunks = 0